export default __webpack_public_path__ + "static/hero-a0703970b867917b1dd9767237fc6469.mp4";